/**
 * Represents an abstract HTTP API.
 */
export default class HttpApi {
    #apiUrl;
    constructor(apiUrl) {
        this.#apiUrl = apiUrl;
    }
    /**
     * Factory function for running GET requests.
     * @param endpoint API endpoint.
     * @param requestInit Additional data passed to request.
     * @returns API response.
     */
    async getRequest(endpoint, requestInit) {
        return fetch(new URL(endpoint, this.#apiUrl), {
            credentials: "include",
            ...requestInit,
        });
    }
    /**
     * Factory function for running POST requests.
     * @param endpoint API endpoint,
     * @param body Data passed to POST request.
     * @param requestInit Additional data passed to request.
     * @returns API response.
     */
    async postRequest(endpoint, body, requestInit) {
        return fetch(new URL(endpoint, this.#apiUrl), {
            method: "POST",
            body: JSON.stringify(body),
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            ...requestInit,
        });
    }
}
//# sourceMappingURL=HttpApi.js.map